module.exports = __webpack_public_path__ + "static/img/icon_vertical.b746ef62.svg";